import axios from "axios";
import { getDateRange } from "src/modules/data-summary/utils/date-utils";

export default async function getDataSummaryCredit({
  dateRangeStart,
  dateRangeEnd,
  year,
  month,
  fromDay,
  toDay,
  page,
  length,
}) {
  try {
    const start = page * length;
    const params = { start, length };

    if (dateRangeStart && dateRangeEnd) {
      params.start_date = dateRangeStart;
      params.end_date = dateRangeEnd;
    } else {
      const { startDate, endDate } = getDateRange({
        year,
        month,
        fromDay,
        toDay,
      });
      params.start_date = startDate;
      params.end_date = endDate;
    }

    const response = await axios.get(
      "/payment/system-admin/api/v1/data-summary/qr-credit-summary",
      { params }
    );

    const resData = response?.data;

    if (
      !resData?.success ||
      !resData?.data ||
      !Array.isArray(resData.data.records)
    ) {
      throw new Error("Invalid response structure from backend");
    }

    return resData.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data?.message || "Server error occurred");
    } else if (error.request) {
      throw new Error("No response from server");
    } else {
      throw error;
    }
  }
}
